import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../assets/scss/components/ui/btn/CacheClearButton.scss';

// Importar iconos (ajustar rutas según tu proyecto)
import ClearCacheIcon from '../../../assets/svg/view/list.svg';
import ClearCacheIconLight from '../../../assets/svg/view/list.svg';
import LoadingIcon from '../../../assets/svg/view/loading.svg';

export default function CacheClearButton({ 
  onClearCache, 
  theme, 
  hasCachedData, 
  showNotification 
}) {
  const [isClearing, setIsClearing] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleClearClick = () => {
    if (!hasCachedData) {
      showNotification?.({
        message: "No hay datos en caché para eliminar",
        severity: "INFO",
        position: { vertical: "top", horizontal: "right" }
      });
      return;
    }
    
    setShowConfirm(true);
  };

  const handleConfirmClear = async () => {
    setIsClearing(true);
    setShowConfirm(false);

    try {
      const success = await onClearCache();
      
      if (success) {
        showNotification?.({
          message: "Caché eliminado exitosamente",
          severity: "SUCCESS",
          position: { vertical: "top", horizontal: "right" }
        });
      } else {
        throw new Error('Error al limpiar caché');
      }
    } catch (error) {
      showNotification?.({
        message: "Error al eliminar el caché",
        severity: "ERROR",
        position: { vertical: "top", horizontal: "right" }
      });
    } finally {
      setIsClearing(false);
    }
  };

  const handleCancelClear = () => {
    setShowConfirm(false);
  };

  if (!hasCachedData && !showConfirm) {
    return null;
  }

  return (
    <>
      <div className={`GM__${theme}-cache-clear-container`}>
        <button
          className={`GM__${theme}-cache-clear-btn ${!hasCachedData ? 'disabled' : ''}`}
          onClick={handleClearClick}
          disabled={isClearing || !hasCachedData}
          title={hasCachedData ? "Limpiar datos guardados" : "No hay datos en caché"}
        >
          {isClearing ? (
            <img 
              src={LoadingIcon} 
              alt="Limpiando..." 
              className={`GM__${theme}-cache-icon spinning`} 
            />
          ) : (
            <img
              src={theme === "dark" ? ClearCacheIconLight : ClearCacheIcon}
              alt="Limpiar caché"
              className={`GM__${theme}-cache-icon`}
            />
          )}
          <span className={`GM__${theme}-cache-text`}>
            {isClearing ? 'Limpiando...' : 'Limpiar datos'}
          </span>
        </button>
      </div>

      {/* Modal de confirmación */}
      {showConfirm && (
        <div className={`GM__${theme}-modal-overlay`}>
          <div className={`GM__${theme}-modal-content`}>
            <h3 className={`GM__${theme}-modal-title`}>
              Confirmar eliminación de datos
            </h3>
            <p className={`GM__${theme}-modal-message`}>
              ¿Está seguro que desea eliminar todos los datos guardados del formulario? 
              Esta acción no se puede deshacer.
            </p>
            <div className={`GM__${theme}-modal-actions`}>
              <button
                className={`GM__${theme}-modal-btn cancel`}
                onClick={handleCancelClear}
              >
                Cancelar
              </button>
              <button
                className={`GM__${theme}-modal-btn confirm`}
                onClick={handleConfirmClear}
              >
                Eliminar datos
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

CacheClearButton.propTypes = {
  onClearCache: PropTypes.func.isRequired,
  theme: PropTypes.string.isRequired,
  hasCachedData: PropTypes.bool.isRequired,
  showNotification: PropTypes.func
};